import { reaction } from 'mobx';
import { useEffect, useRef, useState } from 'react';

import { CarouselMessage } from '../models';
import { useStores } from '../stores';
import { MESSAGE_TYPE_RECEIVED } from '../utilities';
import useConfig from './useConfig';

export default function useCarousel() {
  const { carousel, intentOnInit } = useConfig();
  const { app, bot, chat, chatWindow, network } = useStores();
  const isSent = useRef(false);
  const [isForced, setForced] = useState(false);

  useEffect(
    () =>
      reaction(() => carousel && carousel.enabled && chat.messages.length === 0, setForced, {
        delay: carousel ? carousel.timeout + 200 : 0
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [carousel]
  );

  useEffect(() => {
    if (
      (carousel && !carousel.enabled) ||
      chat.isSpecialMessage ||
      (intentOnInit && intentOnInit.enabled)
    ) {
      return () => {};
    }

    let timeoutId;
    const isChatReady = chatWindow.isOpened && network.isOnline && !network.isSlowConnection;

    if (
      carousel &&
      carousel.enabled &&
      isChatReady &&
      chat.isWelcomeMessage &&
      (isForced || !isSent.current) &&
      app.isReadyLanguage &&
      app.sessionId &&
      bot.isDoneTopFAQsRequest
    ) {
      timeoutId = setTimeout(() => {
        chat.addMessage(
          new CarouselMessage({
            content: {
              hotTopics: bot.hotTopics,
              popularQuestions: bot.topQuestions,
              content: carousel.content
            },
            type: MESSAGE_TYPE_RECEIVED
          })
        );
        isSent.current = true;
      }, carousel.timeout);
    }

    if (chatWindow.isClosed) {
      isSent.current = false;
    }

    return () => {
      if (chat.messages.length === 0) {
        isSent.current = false;
      }

      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [
    app.isReadyLanguage,
    app.sessionId,
    bot.hotTopics,
    bot.topQuestions,
    chat,
    chat.isWelcomeMessage,
    chatWindow.isClosed,
    chatWindow.isOpened,
    isForced,
    network.isOnline,
    network.isSlowConnection,
    carousel,
    intentOnInit,
    bot.isDoneTopFAQsRequest
  ]);
}
